module.exports = __webpack_public_path__ + "static/media/burrito_02_thumb.c02ac375.png";